import React from 'react';
import useLogPage from '../useLogPage';
import LogFilters from '../LogFilters';
import LogTable from '../LogTable';
import LogStatCards from '../LogStatCards';
import { TrendChart, GroupedBarChart } from '../LogCharts';
import { LogService } from '../../../services/activityLogService';

const COLUMNS = [
  { key: 'id',           label: '#',        render: (v) => <span className="al-mono">{v}</span> },
  { key: 'user_id',      label: 'User ID',  render: (v) => <span className="al-mono">{v || 'Guest'}</span> },
  { key: 'page',         label: 'Page',     render: (v) => <span className="al-truncate" title={v}>{v || '—'}</span> },
  { key: 'referrer',     label: 'Referrer', render: (v) => <span className="al-truncate" title={v}>{v || '—'}</span> },
  { key: 'duration_sec', label: 'Duration', render: (v) => v ? `${v}s` : '—' },
  { key: 'device',       label: 'Device' },
  { key: 'browser',      label: 'Browser' },
  { key: 'ip_address',   label: 'IP',       render: (v) => <span className="al-mono">{v || '—'}</span> },
  { key: 'created_at',   label: 'Time',     render: (v) => v ? new Date(v).toLocaleString('en-IN') : '—' },
];

const VisitPageLog = () => {
  const lp = useLogPage(LogService.visitPages);
  const s = lp.stats || {};

  const handleExport = () => {
    const { search, dateFrom, dateTo } = lp.filters;
    LogService.exportVisitPages({
      ...(search   ? { search }              : {}),
      ...(dateFrom ? { date_from: dateFrom } : {}),
      ...(dateTo   ? { date_to:   dateTo   } : {}),
      format: 'excel',
    });
  };

  const stats = [
    { label: 'Total Visits',  value: lp.totalItems.toLocaleString(),              color: '#A855F7' },
    { label: 'Unique Pages',  value: (s.unique_pages ?? 0).toLocaleString(),      color: '#3B82F6' },
    { label: 'Unique Users',  value: (s.unique_users ?? 0).toLocaleString(),      color: '#10B981' },
    { label: 'Avg Duration',  value: s.avg_duration != null ? `${s.avg_duration}s` : '—', color: '#F55D00' },
  ];

  // Top pages bar chart — prefer API donut/breakdown, else empty
  const barData = lp.donut.length
    ? lp.donut
    : Object.entries(s.breakdown || {}).map(([page, count]) => ({
        page: page.length > 20 ? page.slice(0, 20) + '…' : page,
        count,
      }));

  return (
    <div className="al-page">
      <LogStatCards stats={stats} />

      <div className="al-charts">
        <TrendChart title="Page Visits Over Time" data={lp.trend} color="#A855F7" />
        <GroupedBarChart
          title="Top Pages"
          data={barData}
          bars={[{ key: 'count', label: 'Visits' }]}
          xKey="page"
        />
      </div>

      <LogFilters
        filters={lp.filters}
        onFilterChange={lp.handleFilterChange}
        onApply={lp.handleApply}
        onReset={lp.handleReset}
        loading={lp.loading}
      />

      <LogTable
        title="Page Visit Logs"
        columns={COLUMNS}
        rows={lp.rows}
        loading={lp.loading}
        error={lp.error}
        page={lp.page}
        totalPages={lp.totalPages}
        totalItems={lp.totalItems}
        pageSize={lp.filters.pageSize}
        onPageChange={lp.handlePageChange}
        onExport={handleExport}
        onRefresh={lp.handleRefresh}
      />
    </div>
  );
};

export default VisitPageLog;
